module.exports = __webpack_public_path__ + "static/img/pt.67bf8f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/flag/pt.png
// module id = zPqI
// module chunks = 0